<script setup lang="ts">
import {onMounted} from "vue";

defineOptions({
  name:'AppYandex'
})
onMounted(()=>{
  const func = `(function(m,e,t,r,i,k,a){
        m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
        m[i].l=1*new Date();
        for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
        k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)
    })(window, document,'script','https://mc.yandex.ru/metrika/tag.js?id=109299341', 'ym');

    ym(109299341, 'init', {ssr:true, clickmap:true, ecommerce:"dataLayer", referrer: document.referrer, url: location.href, accurateTrackBounce:true, trackLinks:true});`;
  const script = document.createElement('script');
  script.innerHTML = func
  document.head.appendChild(script);


});
</script>

<template>
  <noscript><div><img src="https://mc.yandex.ru/watch/109299341" style="position:absolute; left:-9999px;" alt="" /></div></noscript>
</template>

<style scoped lang="scss">

</style>